import { WifiX } from '@phosphor-icons/react';
import { twMerge } from 'tailwind-merge';
export default function OfflineErrorBox({
  error
}: {
  error: boolean;
}) {
  return <div className={twMerge('fixed left-0 right-0 top-16 z-20 w-11/12 mx-auto rounded-md bg-primary/50 backdrop-blur-2xl p-3 transition-all', !error && 'hidden')} data-sentry-component="OfflineErrorBox" data-sentry-source-file="offline-error-box.tsx">
      <div className="flex gap-3">
        <WifiX size={20} className="flex-shrink-0 text-foreground" aria-hidden="true" data-sentry-element="WifiX" data-sentry-source-file="offline-error-box.tsx" />

        <p className="text-sm leading-4 text-foreground">
          Internet connection unavailable. Please connect to the internet and try again.
        </p>
      </div>
    </div>;
}